import { Attributes, Misc, Model, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class BankTransferLetterCapitalCriteria extends ValueObject {
    static typeName = "BankTransferLetterCapitalCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    public entityId: number | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public reportDate: Date | null = null;

    @Attributes.Nullable()
    public investorId: number | null = null;

    @Attributes.Nullable()
    public investorReferralTypeId: number | null = null;

    public inOnly: boolean | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Bank Transfer Letter Criteria";
    }
}